import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { registerLocaleData } from "@angular/common";
import localeAr from "@angular/common/locales/ar";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// QSL-10245: register Arabic locale data so angular-calendar (and Angular date
// pipes) render Arabic weekday/month names when the UI language is Arabic.
registerLocaleData(localeAr, "ar");

if (environment.production) {
  enableProdMode();
}

// Register service worker for Firebase Cloud Messaging
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
